import { Component, OnInit } from '@angular/core';
import { SkyConfirmationDialogConfig } from './confirmation-dialog-config';
import { SkyConfirmationDialogType } from './confirmation-dialog-type';
import { SkyConfirmationDialogButton } from './confirmation-dialog-button';
import { SkyModalInstance } from '../modal/modal-instance';
import { SkyResources } from '../resources';


export class SkyConfirmationDialogComponent implements OnInit {
  public buttons: Array<SkyConfirmationDialogButton>;

  constructor(
    public context: SkyConfirmationDialogConfig,
    public instance: SkyModalInstance) {}

  public ngOnInit() {
    if (!this.context.type) {
      this.context.type = SkyConfirmationDialogType.YesCancelDialog;
    }

    if (!this.context.buttons) {
      this.context.buttons = new Array<SkyConfirmationDialogButton>();
    }

    this.createButtons();
  }

  private createButtons() {
    this.buttons = this.getDefaultButtons();

    // If button config is supplied through the config object, use those values
    this.overrideButtonConfig();
  }

  private getDefaultButtons(): Array<SkyConfirmationDialogButton> {
    switch (this.context.type) {
      case SkyConfirmationDialogType.OKDialog: return [
        {
          text: SkyResources.getString('confirm_dialog_default_ok_text'),
          autofocus: true,
          buttonType: 'primary'
        }
      ];
      case SkyConfirmationDialogType.YesNoCancelDialog: return [
        {
          text: SkyResources.getString('confirm_dialog_default_yes_text'),
          autofocus: true,
          buttonType: 'primary'
        },
        {
          text: SkyResources.getString('confirm_dialog_default_no_text'),
          buttonType: 'default'
        },
        {
          text: SkyResources.getString('confirm_dialog_default_cancel_text'),
          buttonType: 'link'
        }
      ];
      default: return [
        {
          text: SkyResources.getString('confirm_dialog_default_yes_text'),
          autofocus: true,
          buttonType: 'primary'
        },
        {
          text: SkyResources.getString('confirm_dialog_default_cancel_text'),
          buttonType: 'link'
        }
      ];
    }
  }

  private overrideButtonConfig() {
    const configButtons = this.context.buttons;

    this.buttons.forEach((button: any, i: number) => {
      if (configButtons[i]) {
        if (configButtons[i].text) {
          this.buttons[i].text = this.context.buttons[i].text;
        }

        if (configButtons[i].autofocus) {
          this.buttons[0].autofocus = false; // clear out default
          this.buttons[i].autofocus = true;
        }
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-confirmation-dialog',
  template: `<div class="sky-confirmation-dialog">
  <sky-modal>
    <sky-modal-content>
      <div class="sky-confirmation-dialog-container">
        <div class="sky-confirmation-dialog-message-container">
          <span class="sky-confirmation-dialog-message sky-emphasized">
            {{ context.message }}
          </span>
        </div>
        <div class="sky-confirmation-dialog-buttons">
          <button
            *ngFor="let btn of buttons"
            type="button"
            class="sky-btn sky-confirmation-dialog-btn sky-btn-{{ btn.buttonType }}"
            (click)="instance.close(btn.text)"
            [attr.autofocus]="btn.autofocus ? 'autofocus' : null"
          >
            {{ btn.text }}
          </button>
        </div>
      </div>
    </sky-modal-content>
  </sky-modal>
</div>
`,
  styles: [`.sky-confirmation-dialog-message-container {
  padding-top: 5px;
  margin-bottom: 30px;
}

.sky-confirmation-dialog-buttons {
  padding-bottom: 5px;
}

.sky-confirmation-dialog-btn {
  min-width: 15%;
  margin-right: 5px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyConfirmationDialogConfig, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
